import { render, staticRenderFns } from "./EditSeguroiprevnumeroparcelaPage.vue?vue&type=template&id=92c31242"
import script from "./EditSeguroiprevnumeroparcelaPage.vue?vue&type=script&lang=js"
export * from "./EditSeguroiprevnumeroparcelaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports